import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SuccessClaimComponent } from 'src/app/features/claims/dialogs/success-claim/success-claim.component';
import { Admin } from 'src/app/models/admin/admin.model';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'app-resend-welcomeletter',
  templateUrl: './resend-welcomeletter.component.html',
  styleUrls: ['./resend-welcomeletter.component.scss']
})
export class ResendWelcomeletterComponent {

  admin = new Admin("", "", "", "", 0, "", true, 0, "");
  successMessage: string = '';

  constructor(private dialogRef: MatDialogRef<ResendWelcomeletterComponent>, private adminService: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: Admin, private matDialog: MatDialog) {
    this.admin = data;
  }
  closeDialog() {
    this.dialogRef.close();
  }

  resendLetter() {
    this.adminService.resendWelcomeLetter(this.admin).subscribe({
      next: (res: any) => {
        
        if (res) {
          if (res) {
            this.successMessage = res;
            this.matDialog.open(SuccessClaimComponent, {
              data: this.successMessage
              //disableClose: true
            });
          }
          this.successMessage = '';
          this.closeDialog();
        }

        this.successMessage = "";
      },
      error: (err: any) => {
        console.log(err);
      },
      complete: () => {
        console.log('complete');
      }
    });
  }
}
